<!-- Compiled at 2026-05-13T13:50:05.286Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<Llama-MainLayout
					[$formDirective]="$formDirective"
					[$disabled]="$disabled"
					[$ignoreValidations]="$ignoreValidations"
					[screenTitle]="'My Expenses'"
					[isForExternalUser]=""
				>
					<ng-template
						data-content-area="content"
						let-$scope="$scope"
						let-$formDirective="$formDirective"
						let-$disabled="$disabled"
					>
						<div data-content-area="content" data-defined-in="Llama.MyExpenses">
							<div
								class="layout-block vertical"
								style="padding: 1rem"
								[style.align-items]="'inherit'"
								[style.gap]="'1em'"
							>
								<mat-card>
									<mat-card-content>
										<div style="display: inline-block">
											<mat-form-field
												class="has-dateChange-handler"
												appearance="outline"
												(dateChange)="handler_DatePickerBlock_20_dateChange_loadExpenses_0($event, {  })"
												class="fill"
											>
												@let $fc_20_1 = getFormControl(screen,
												'filterDateFrom', 20, $scope, $formDirective,
												$disabled, $ignoreValidations);
												<mat-label
													[innerHtml]="'Date from' | escapeHtml"
												></mat-label>
												<input
													class="has-dateChange-handler"
													(dateChange)="handler_DatePickerBlock_20_dateChange_loadExpenses_0($event, {  })"
													matInput
													[formControl]="$fc_20_1"
													[matDatepicker]="picker746375"
												/>
												<mat-datepicker-toggle
													matSuffix
													[for]="picker746375"
												></mat-datepicker-toggle>
												<mat-datepicker #picker746375></mat-datepicker>
												@for(error of $fc_20_1.errors ?? {} | keyvalue;
												track error.key) {
												<mat-error
													*ngIf="typeof error.value == 'string'"
													[innerHtml]="error.value | escapeHtml: 'safe'"
												/>
												}
											</mat-form-field>
										</div>
										<div style="display: inline-block">
											<mat-form-field
												class="has-dateChange-handler"
												appearance="outline"
												style="margin-left: 0.5em"
												(dateChange)="handler_DatePickerBlock_24_dateChange_loadExpenses_0($event, {  })"
												class="fill"
											>
												@let $fc_24_1 = getFormControl(screen,
												'filterDateTo', 24, $scope, $formDirective,
												$disabled, $ignoreValidations);
												<mat-label
													[innerHtml]="'Date to' | escapeHtml"
												></mat-label>
												<input
													class="has-dateChange-handler"
													(dateChange)="handler_DatePickerBlock_24_dateChange_loadExpenses_0($event, {  })"
													matInput
													[formControl]="$fc_24_1"
													[matDatepicker]="picker523271"
												/>
												<mat-datepicker-toggle
													matSuffix
													[for]="picker523271"
												></mat-datepicker-toggle>
												<mat-datepicker #picker523271></mat-datepicker>
												@for(error of $fc_24_1.errors ?? {} | keyvalue;
												track error.key) {
												<mat-error
													*ngIf="typeof error.value == 'string'"
													[innerHtml]="error.value | escapeHtml: 'safe'"
												/>
												}
											</mat-form-field>
										</div>
										<mat-form-field
											class="has-selectionChange-handler"
											appearance="outline"
											style="margin-left: 1em"
											(selectionChange)="handler_DropdownBlock_21_selectionChange_loadExpenses_0($event, {  })"
										>
											@let $fc_21_1 = getFormControl(screen,
											'filterProjectId', 21, $scope, $formDirective,
											$disabled, $ignoreValidations);

											<mat-label
												[innerHtml]="'Projects' | escapeHtml"
											></mat-label>
											<mat-select
												class="has-selectionChange-handler"
												(selectionChange)="handler_DropdownBlock_21_selectionChange_loadExpenses_0($event, {  })"
												[formControl]="$fc_21_1"
												[compareWith]="$compare"
												#select_21="matSelect"
												[lgFormComponent]="select_21"
												[lgFormValue]="screen.filterProjectId"
												canSelectNullableOptions
											>
												@let emptyOption_21 = [null, 'All Projects', true];
												@if (emptyOption_21) {
												<mat-option [value]="emptyOption_21[0]"
													>{{ emptyOption_21[1] }}</mat-option
												>
												}

												<mat-option
													*ngFor="let $option of (screen.projectsOptions); let $index = index"
													[value]="$option.id"
												>
													<span
														[innerHtml]="$option.name | escapeHtml"
														style="margin: auto 0"
													></span>
												</mat-option>
											</mat-select>

											@for(error of $fc_21_1.errors ?? {} | keyvalue; track
											error.key) {
											<mat-error
												*ngIf="typeof error.value == 'string'"
												[innerHtml]="error.value | escapeHtml: 'safe'"
											/>
											}
										</mat-form-field>
										<mat-form-field
											*ngIf="$any(screen.filterProjectId)?.$isOther"
										>
											@let $fc_21_3 = getFormControl(screen.filterProjectId,
											'$otherValue', 21, $scope, $formDirective, $disabled,
											$ignoreValidations);
											<mat-label
												[innerHtml]="'Projects' + ' (Other)' | escapeHtml"
											></mat-label>
											<input type="text" matInput [formControl]="$fc_21_3" />
										</mat-form-field>

										<mat-form-field
											class="has-selectionChange-handler"
											appearance="outline"
											style="margin-left: 0.5em"
											(selectionChange)="handler_DropdownBlock_25_selectionChange_loadExpenses_0($event, {  })"
										>
											@let $fc_25_1 = getFormControl(screen,
											'filterChargeability', 25, $scope, $formDirective,
											$disabled, $ignoreValidations);

											<mat-label
												[innerHtml]="'Is chargeable' | escapeHtml"
											></mat-label>
											<mat-select
												class="has-selectionChange-handler"
												(selectionChange)="handler_DropdownBlock_25_selectionChange_loadExpenses_0($event, {  })"
												[formControl]="$fc_25_1"
												[compareWith]="$compare"
												#select_25="matSelect"
												[lgFormComponent]="select_25"
												[lgFormValue]="screen.filterChargeability"
												canSelectNullableOptions
											>
												@let emptyOption_25 = [null, 'Both', true]; @if
												(emptyOption_25) {
												<mat-option [value]="emptyOption_25[0]"
													>{{ emptyOption_25[1] }}</mat-option
												>
												}

												<mat-option
													*ngFor="let $option of (screen.chargeabilitiesOptions); let $index = index"
													[value]="$option.id"
												>
													<span
														[innerHtml]="$option.label | escapeHtml"
														style="margin: auto 0"
													></span>
												</mat-option>
											</mat-select>

											@for(error of $fc_25_1.errors ?? {} | keyvalue; track
											error.key) {
											<mat-error
												*ngIf="typeof error.value == 'string'"
												[innerHtml]="error.value | escapeHtml: 'safe'"
											/>
											}
										</mat-form-field>
										<mat-form-field
											*ngIf="$any(screen.filterChargeability)?.$isOther"
										>
											@let $fc_25_3 =
											getFormControl(screen.filterChargeability,
											'$otherValue', 25, $scope, $formDirective, $disabled,
											$ignoreValidations);
											<mat-label
												[innerHtml]="'Is chargeable' + ' (Other)' | escapeHtml"
											></mat-label>
											<input type="text" matInput [formControl]="$fc_25_3" />
										</mat-form-field>

										<lowgile-table
											#datatable_5
											[dataSignal]="_DataTableBlock_collectionCodeSignal_5(datatable_5, { app, screen, $pathSegments, $disabled })"
											[trackBy]="trackByAutomatic"
											[entity]="This.Expense"
											[columns]="_DataTableBlock_columns_5(screen)"
											[showSettings]="true"
											[userDefinedConfiguration]="undefined"
											[usePaging]="true"
											[pageSize]="20"
											[pageSizeOptions]="[10, 20, 50]"
											[useGlobalFilter]="false"
											[debouncingDelay]="250"
											[stickyHeader]="true"
											[additionalFindOptions]="_DataTableBlock_additionalFindOptions_5({ app, screen, $pathSegments, $disabled })"
											[additionalHeaderRows]="[]"
											[additionalFooterRows]="[]"
											[allClasses]="$Modules"
											[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
											[surroundingScope]="$scope"
											#$table_5="lowgileTable"
										>
											<ng-container [lowgile-column]="'expenseDate'">
												<th mat-header-cell *matHeaderCellDef>
													<span
														[innerHtml]="'Expense Date' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</th>
												<td
													mat-cell
													*matCellDef="let item; let index = index"
													[attr.data-label]="'Expense Date'"
												>
													<ng-container
														*lowgileScope="item; as: 'item'; let $scope"
													>
														<ng-container
															*lowgileScope="index; as: 'index'; let $scope"
														>
															<span
																[innerHtml]="_DataTableColumnBlock_cellText_13({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</ng-container>
													</ng-container>
												</td>
											</ng-container>
											<ng-container
												[lowgile-column]="('expenseDate') + '$$filter'"
											>
												<th mat-header-cell *matHeaderCellDef></th>
											</ng-container>

											<ng-container [lowgile-column]="'name'">
												<th mat-header-cell *matHeaderCellDef>
													<span
														[innerHtml]="'Name' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</th>
												<td
													mat-cell
													*matCellDef="let item; let index = index"
													[attr.data-label]="'Name'"
												>
													<ng-container
														*lowgileScope="item; as: 'item'; let $scope"
													>
														<ng-container
															*lowgileScope="index; as: 'index'; let $scope"
														>
															<span
																[innerHtml]="_DataTableColumnBlock_cellText_14({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</ng-container>
													</ng-container>
												</td>
											</ng-container>
											<ng-container [lowgile-column]="('name') + '$$filter'">
												<th mat-header-cell *matHeaderCellDef></th>
											</ng-container>

											<ng-container [lowgile-column]="'status'">
												<th mat-header-cell *matHeaderCellDef>
													<span
														[innerHtml]="'Status' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</th>
												<td
													mat-cell
													*matCellDef="let item; let index = index"
													[attr.data-label]="'Status'"
												>
													<ng-container
														*lowgileScope="item; as: 'item'; let $scope"
													>
														<ng-container
															*lowgileScope="index; as: 'index'; let $scope"
														>
															<span
																[innerHtml]="_DataTableColumnBlock_cellText_22({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</ng-container>
													</ng-container>
												</td>
											</ng-container>
											<ng-container
												[lowgile-column]="('status') + '$$filter'"
											>
												<th mat-header-cell *matHeaderCellDef></th>
											</ng-container>

											<ng-container [lowgile-column]="'project'">
												<th mat-header-cell *matHeaderCellDef>
													<span
														[innerHtml]="'Project' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</th>
												<td
													mat-cell
													*matCellDef="let item; let index = index"
													[attr.data-label]="'Project'"
												>
													<ng-container
														*lowgileScope="item; as: 'item'; let $scope"
													>
														<ng-container
															*lowgileScope="index; as: 'index'; let $scope"
														>
															<span
																[innerHtml]="_DataTableColumnBlock_cellText_23({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</ng-container>
													</ng-container>
												</td>
											</ng-container>
											<ng-container
												[lowgile-column]="('project') + '$$filter'"
											>
												<th mat-header-cell *matHeaderCellDef></th>
											</ng-container>

											<ng-container [lowgile-column]="'category'">
												<th mat-header-cell *matHeaderCellDef>
													<span
														[innerHtml]="'Category' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</th>
												<td
													mat-cell
													*matCellDef="let item; let index = index"
													[attr.data-label]="'Category'"
												>
													<ng-container
														*lowgileScope="item; as: 'item'; let $scope"
													>
														<ng-container
															*lowgileScope="index; as: 'index'; let $scope"
														>
															<span
																[innerHtml]="_DataTableColumnBlock_cellText_15({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</ng-container>
													</ng-container>
												</td>
											</ng-container>
											<ng-container
												[lowgile-column]="('category') + '$$filter'"
											>
												<th mat-header-cell *matHeaderCellDef></th>
											</ng-container>

											<ng-container [lowgile-column]="'currency'">
												<th mat-header-cell *matHeaderCellDef>
													<span
														[innerHtml]="'Currency' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</th>
												<td
													mat-cell
													*matCellDef="let item; let index = index"
													[attr.data-label]="'Currency'"
												>
													<ng-container
														*lowgileScope="item; as: 'item'; let $scope"
													>
														<ng-container
															*lowgileScope="index; as: 'index'; let $scope"
														>
															<span
																[innerHtml]="_DataTableColumnBlock_cellText_16({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</ng-container>
													</ng-container>
												</td>
											</ng-container>
											<ng-container
												[lowgile-column]="('currency') + '$$filter'"
											>
												<th mat-header-cell *matHeaderCellDef></th>
											</ng-container>

											<ng-container [lowgile-column]="'vatAmount'">
												<th mat-header-cell *matHeaderCellDef>
													<span
														[innerHtml]="'VAT' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</th>
												<td
													mat-cell
													*matCellDef="let item; let index = index"
													[attr.data-label]="'VAT'"
												>
													<ng-container
														*lowgileScope="item; as: 'item'; let $scope"
													>
														<ng-container
															*lowgileScope="index; as: 'index'; let $scope"
														>
															<span
																[innerHtml]="_DataTableColumnBlock_cellText_17({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</ng-container>
													</ng-container>
												</td>
											</ng-container>
											<ng-container
												[lowgile-column]="('vatAmount') + '$$filter'"
											>
												<th mat-header-cell *matHeaderCellDef></th>
											</ng-container>

											<ng-container [lowgile-column]="'tipAmount'">
												<th mat-header-cell *matHeaderCellDef>
													<span
														[innerHtml]="'Tip' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</th>
												<td
													mat-cell
													*matCellDef="let item; let index = index"
													[attr.data-label]="'Tip'"
												>
													<ng-container
														*lowgileScope="item; as: 'item'; let $scope"
													>
														<ng-container
															*lowgileScope="index; as: 'index'; let $scope"
														>
															<span
																[innerHtml]="_DataTableColumnBlock_cellText_18({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</ng-container>
													</ng-container>
												</td>
											</ng-container>
											<ng-container
												[lowgile-column]="('tipAmount') + '$$filter'"
											>
												<th mat-header-cell *matHeaderCellDef></th>
											</ng-container>

											<ng-container [lowgile-column]="'totalAmount'">
												<th mat-header-cell *matHeaderCellDef>
													<span
														[innerHtml]="'Total' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</th>
												<td
													mat-cell
													*matCellDef="let item; let index = index"
													[attr.data-label]="'Total'"
												>
													<ng-container
														*lowgileScope="item; as: 'item'; let $scope"
													>
														<ng-container
															*lowgileScope="index; as: 'index'; let $scope"
														>
															<span
																[innerHtml]="_DataTableColumnBlock_cellText_19({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</ng-container>
													</ng-container>
												</td>
											</ng-container>
											<ng-container
												[lowgile-column]="('totalAmount') + '$$filter'"
											>
												<th mat-header-cell *matHeaderCellDef></th>
											</ng-container>
										</lowgile-table>
									</mat-card-content>
								</mat-card>
							</div>
						</div>
					</ng-template>
				</Llama-MainLayout>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
